<template>
  <path
    d="M8.99997 6.00024C8.99997 6.56024 9.44997 7.00024 9.99997 7.00024H15.59L4.69997 17.8902C4.30997 18.2802 4.30997 18.9102 4.69997 19.3002C5.08997 19.6902 5.71997 19.6902 6.10997 19.3002L17 8.41024V14.0002C17 14.5502 17.45 15.0002 18 15.0002C18.55 15.0002 19 14.5502 19 14.0002V6.00024C19 5.45024 18.55 5.00024 18 5.00024H9.99997C9.44997 5.00024 8.99997 5.45024 8.99997 6.00024Z"
  />
</template>
